import {useUnitsContext} from "context/UnitsContext";

export const useUnits = () => {
  return useUnitsContext().units;
};

export const useSetUnits = () => {
  return useUnitsContext().setUnits;
};
